import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";

import StatCard from "components/dashboard/StatCard";
import Badge from "components/Badge";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import {UserAgentUtils} from "utils/useragent";

EffectiveTurnoverCard.propTypes = {
    value: PropTypes.number,
    currency: PropTypes.string,
    loading: PropTypes.bool.isRequired,
};

function EffectiveTurnoverCard({value, currency, loading}) {
    const intl = useIntl();

    return (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.caEffectif" />}
            value={
                value !== null ? (
                    <FormattedNumberWithCurrency
                        value={value}
                        currency={currency}
                    />
                ) : "—"
            }
            tag={
                <Badge
                    color="online"
                    indicator={'circle'}
                    isBold={false}
                    labelSize={14}
                    size={'large'}
                    border={true}
                >
                    <FormattedMessage id="dashboard.card.tag.online" />
                </Badge>
            }
            loading={loading}
            tooltip={intl.formatMessage({ id: "dashboard.tooltip.caEffectif" })}
            tagBelow={UserAgentUtils.isMobile()}
        />
    );
}

export default EffectiveTurnoverCard;
